import { BacklogTask, Dimension, DimensionKind, Review, ReviewStatus, Role, TaskComment, UserDoc } from '../domain/types';
import { supabaseApi, supabaseFetchBacklog, supabaseFetchTask, supabaseFetchAudit } from './supabase';

export interface BootstrapResult {
  ok: boolean;
  me: string;
  role: Role;
  myEspacios: string[]; // espacios a cargo del usuario actual (solo responsable de espacio)
  statuses: string[];
  proyectoStatuses: string[];
  tipos: string[];
  urgencias: string[];
  dificultades: string[];
  dimensionKinds: string[];
  dimensionLabels: Record<string, string>;
  dimensions: Record<string, Dimension[]>;
}

interface ApiClient {
  bootstrap: () => Promise<BootstrapResult>;
  initFirstAdmin: () => Promise<{ ok: true; created?: boolean; email?: string }>;
  syncMyClaims: () => Promise<{ role: string | null }>;

  listAccessRoster: () => Promise<UserDoc[]>;
  listAssignableUsers: () => Promise<UserDoc[]>;
  upsertUser: (u: Partial<UserDoc>) => Promise<{ ok: true; email: string }>;
  setRole: (p: { email: string; role: string }) => Promise<{ ok: true }>;
  removeUser: (p: { email: string }) => Promise<{ ok: true }>;
  adminUpsertUser: (u: Partial<UserDoc>) => Promise<{ ok: true; email: string; created: boolean }>;
  adminRemoveUser: (p: { email: string }) => Promise<{ ok: true; email: string; authDeleted: boolean }>;

  listUserEspacios: () => Promise<Record<string, string[]>>;
  setUserEspacios: (p: { email: string; espacios: string[] }) => Promise<{ ok: true; email: string }>;

  listAllDimensions: (p?: { activeOnly?: boolean }) => Promise<Record<string, Dimension[]>>;
  upsertDimension: (p: { kind: DimensionKind; payload: Record<string, unknown> }) => Promise<{ ok: true; id?: string }>;
  deactivateDimension: (p: { kind: DimensionKind; id: string }) => Promise<{ ok: true }>;

  createTask: (payload: Record<string, unknown>) => Promise<{ ok: true; id: string; status: string }>;
  updateTask: (p: { id: string; updates: Record<string, unknown> }) => Promise<{ ok: true; changed: number }>;
  approveTask: (p: { id: string; edits?: Record<string, unknown> }) => Promise<{ ok: true }>;
  rejectTask: (p: { id: string; reason: string }) => Promise<{ ok: true }>;

  listComments: (taskId: string) => Promise<TaskComment[]>;
  addComment: (p: { taskId: string; body: string }) => Promise<{ ok: true; id: string }>;

  listReviews: (p?: { status?: ReviewStatus }) => Promise<Review[]>;
  submitReview: (p: { task_id: string; valoracion: string; descripcion: string }) => Promise<{ ok: true; task_id: string; valoracion: string }>;

  seedTaxonomy: () => Promise<{ ok: true; counts: Record<string, number> }>;
  runDeadlineCheck: () => Promise<{ ok: true; warned?: number }>;
}

export const api: ApiClient = supabaseApi as ApiClient;

export async function fetchBacklog(role: string, email: string): Promise<BacklogTask[]> {
  return supabaseFetchBacklog(role, email);
}

export async function fetchTask(id: string): Promise<BacklogTask | null> {
  return supabaseFetchTask(id);
}

export async function fetchAuditFor(id: string): Promise<
  { timestamp: string; action: string; field: string; old_value: string; new_value: string; by: string }[]
> {
  return supabaseFetchAudit(id);
}
